import type { SVGProps } from 'react';

const SvgColumns13 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 16" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M3.167.5A2.5 2.5 0 0 0 .667 3v10a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V3a2.5 2.5 0 0 0-2.5-2.5zm1.666 1.667H3.167A.833.833 0 0 0 2.333 3v10c0 .46.373.833.834.833h1.666zM6.5 13.833h8.333c.46 0 .834-.373.834-.833V3a.833.833 0 0 0-.834-.833H6.5z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgColumns13;
